import React from "react";

function IncredibleCard(props) {
  const data = props.data;
  return (
    <div className="IncredibleCard">
      <img src={data.imageSrc} alt="click here" />
      <h4 className="cardHeading">
        <span>{data.headingText}</span> {data.heading}
      </h4>
      <h6>{data.subHeading}</h6>
      <p className="para mb-4">{data.text}</p>
      <a className="cardLink" href="#">
        {data.link}
      
      </a>
    </div>
  );
}

export default IncredibleCard;
